import InteractionBase from '../InteractionBase';
import { StatePlayfulStretchingPlay } from './states/StatePlayfulStretchingPlay';
import { StatePlayfulStretchingSelect } from './states/StatePlayfulStretchingSelect';
import { TRACK_EVENTS } from 'game/tracking/stats.js';
const assetpack = require('../../../../assets/assetpack_playfulstretching.json');

export default class InteractionPlayfulStretching extends InteractionBase {
  constructor() {
    super('playful_stretching');
  }
  init({ tracking = {} }) {
    this.tracking = tracking;
  }
  preload() {
    this.game.loader.loadAssetPack(
      assetpack,
      Object.keys(assetpack),
      this.handleLoadComplete.bind(this)
    );
  }
  handleLoadComplete() {
    this.add.image(910, 390, 'background_pink');

    this._stateSelect = new StatePlayfulStretchingSelect(this);
    this._statePlay = new StatePlayfulStretchingPlay(this);

    this._stateSelect.on('selected', this.handleUserSelection, this);
    this._statePlay.on('state_complete', this.endInteraction, this);

    this.stateMachine.setState(this._stateSelect);
  }

  handleUserSelection(animal) {
    const animalTrackingNames = {
      snuffleupagus: 'Snuffleupagus',
      cat: 'Cat',
      giraffe: 'Giraffe',
    };
    const buttonName = animalTrackingNames[animal];
    this.game.stats.track(TRACK_EVENTS.GAME_MENU_CLICK, { buttonName });
    this.game.stats.setScreenName(this.tracking.INTERACTION2);

    this.stateMachine.setState(this._statePlay, { animal });
  }

  shutdown() {
    this.game.vo.stop();
    super.shutdown();
  }
}
